import React, { Component } from 'react';

import PortfolioItem from '../portfolio-item/portfolio-item.component';
 
class PortfolioSection extends Component {
    render() {
        return (
            <>
                {/* ======= Portfolio Section ======= */}
                <section id="portfolio" className="portfolio section-bg">
                <div className="container">

                    <div className="section-title">
                        <h2>Portfolio</h2>
                        {/* <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> */}
                    </div>

                    {/* <div className="row" data-aos="fade-up">
                        <div className="col-lg-12 d-flex justify-content-center">
                                <ul id="portfolio-flters">
                                <li data-filter="*" className="filter-active">All</li>
                                <li data-filter=".filter-app">App</li>
                                <li data-filter=".filter-card">Card</li>
                                <li data-filter=".filter-web">Web</li>
                            </ul>
                        </div>
                    </div> */}

                    <div className="row portfolio-container" data-aos="fade-up" data-aos-delay="100">
                        {/* custom portfolio-item */}
                        <PortfolioItem/>
                    </div>
                </div>
                </section>{/* End Portfolio Section */}
            </>
        )
    }
}
export default PortfolioSection;